import classes from './ComponentOverflow.module.scss'
import { forwardRef } from 'react'
import type { ReactNode } from 'react'

interface Props {
  maxWidth?: number
  children: ReactNode
}

const WrappedChildren = forwardRef((
  {
    children,
    maxWidth
  }: Props,
  ref: any
) =>
  <div
    className={classes.WrappedChildren}
    ref={ref}
    style={
      {
        width: maxWidth
          ? `${maxWidth}px`
          : undefined
      }
    }
  >
    {children}
  </div>
)

export default WrappedChildren
